import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Mail, MapPin, ArrowRight } from "lucide-react";

const ContactSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <section ref={ref} className="bg-[#1d1d1f] py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
          >
            <p className="text-[13px] font-medium text-white/40 uppercase tracking-widest mb-4">Kontakt</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-8">
              Sprechen wir<br />über Ihr Projekt.
            </h2>
            <p className="text-[16px] text-white/50 leading-relaxed mb-10">
              Ob 3D-Druck, CAD-Konstruktion oder technische Zeichnung:
              Anforderungen schildern, wir melden uns innerhalb von 24 Stunden
              mit einem kostenlosen Kostenvoranschlag.
            </p>
            <a
              href="mailto:konstantin.florian.kalla@3d-druck-potsdam.de"
              className="inline-flex items-center gap-2 bg-white text-[#1d1d1f] text-[15px] font-semibold px-6 py-3.5 rounded-full hover:bg-white/90 transition-colors"
            >
              Anfrage stellen
              <ArrowRight className="w-4 h-4" />
            </a>
          </motion.div>

          {/* Right */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="space-y-8"
          >
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center shrink-0 mt-0.5">
                <MapPin className="w-4 h-4 text-white/50" />
              </div>
              <div>
                <p className="text-[12px] text-white/30 uppercase tracking-wider mb-1">Adresse</p>
                <address className="not-italic text-[15px] text-white/70 leading-relaxed">
                  3D-Druck Potsdam<br />
                  Konstantin Florian Kalla<br />
                  Brauerstraße 1<br />
                  14467 Potsdam
                </address>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center shrink-0 mt-0.5">
                <Mail className="w-4 h-4 text-white/50" />
              </div>
              <div>
                <p className="text-[12px] text-white/30 uppercase tracking-wider mb-1">E-Mail</p>
                <a
                  href="mailto:konstantin.florian.kalla@3d-druck-potsdam.de"
                  className="text-[15px] text-white/70 hover:text-white transition-colors break-all"
                >
                  konstantin.florian.kalla@3d-druck-potsdam.de
                </a>
              </div>
            </div>

            <div className="pt-4 border-t border-white/10">
              <p className="text-[12px] text-white/30 uppercase tracking-wider mb-4">So geht's</p>
              <ol className="space-y-3">
                {[
                  "Mail mit Anforderungen & Modell (STL / STEP / Skizze)",
                  "Kostenloser Kostenvoranschlag innerhalb von 24 h",
                  "Freigabe und Produktionsbeginn",
                  "Lieferung sorgfältig verpackt",
                ].map((step, i) => (
                  <li key={i} className="flex items-start gap-3 text-[14px] text-white/50">
                    <span className="text-white/20 shrink-0 w-4">{i + 1}.</span>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;
